export default "__VITE_ASSET__C_I1suY9__"